"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CibliLogo = CibliLogo;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("./utils");
function CibliLogo({ className, imgClassName }) {
    return (0, jsx_runtime_1.jsx)("img", { src: "/logo.svg", alt: "Cibli", className: (0, utils_1.cn)('h-10', imgClassName) });
}
